export default "__VITE_ASSET__Cw5m_0AW__"